import React from 'react';
import { useI18nContext } from '../../context/language/use-i18n-context';
import { useUserContext } from '../../context/user';
import { AppConfig } from '../../utils/constants';
import ts from './i18n';
import './footer.css';

export const Footer: React.FC = () => {
  const { i18nString } = useI18nContext();
  const userInfo = useUserContext();
  const year = new Date().getFullYear();

  if (!userInfo) {
    return null;
  }

  const showPassPolicyLink =
    userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.unitedStates ||
    userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.chile ||
    userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.china ||
    userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.taiwan ||
    userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.hongKong ||
    userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.canada ||
    userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.korea;
  const getPassPolicyLink = () => {
    if (userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.chile)
      return '/terms-and-conditions';
    else if (
      userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.china ||
      userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.taiwan ||
      userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.hongKong
    )
      return 'https://nikehr.nike.com/?q=browse/pay-benefits/employee-discounts/1921';
    else if (userInfo.passplayUser?.userLocationId === AppConfig.policyLocationIds.korea)
      return 'https://niketech.service-now.com/nikehr?id=kb_article_view&sys_kb_id=d17213cbc3749e5442d96c3bb0013119&autoLang=false';
    else return 'https://nikehr.nike.com/node/15763';
  };

  const generatePrivacyPolicyLink = () => {
    const countryCode = userInfo?.passplayUser?.userLocationId;
    if (typeof countryCode !== 'number' || isNaN(countryCode)) {
      return (
        AppConfig.privacyPolicyLinks.find(item => item.countryCode === 840)?.link ||
        'http://agreementservice.svs.nike.com/us/en_us/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=us&language=en&requestType=redirect'
      );
    }
    return (
      AppConfig.privacyPolicyLinks.find(item => item.countryCode === countryCode)?.link ||
      AppConfig.privacyPolicyLinks.find(item => item.countryCode === 840)?.link ||
      'http://agreementservice.svs.nike.com/us/en_us/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=us&language=en&requestType=redirect'
    );
  };

  return (
    <>
      <footer className="employee__footer" data-testid="footer">
        <div className="copyright" data-testid="copyright">
          &copy; {year} - {i18nString(ts.FOOTER_RIGHTS)}
        </div>
        <div className="footer__links">
          {showPassPolicyLink && (
            <a href={getPassPolicyLink()} data-testid="passpolicy">
              {i18nString(ts.FOOTER_PASS_POLICY)}
            </a>
          )}
          <a href={generatePrivacyPolicyLink()} data-testid="privacypolicy">
            {i18nString(ts.FOOTER_PRIVACY_POLICY)}
          </a>
          <a
            href={`https://agreementservice.svs.nike.com/rest/agreement?agreementType=termsOfUse&uxId=com.nike.store.passplay&country=${userInfo?.passplayUser?.countryAlpha2}&language=en&requestType=redirect`}
            target="blank"
            data-testid="termsofuse"
          >
            {i18nString(ts.FOOTER_TERMS_OF_USE)}
          </a>
          <a
            href="https://nikehr.nike.com/?q=page/comp-product-policy-16349"
            target="blank"
            data-testid="compproductpolicy"
          >
            {i18nString(ts.COMP_PRODUCT_POLICY)}
          </a>
        </div>
      </footer>
    </>
  );
};
